import _get from 'lodash/get';


const getErrors = state => _get(state, 'siteStaticPages.errors');
export const getLoadSiteStaticPagesError = state => (
  _get(getErrors(state), 'loadSiteStaticPagesError')
);
export const getEditPageNameError = state => _get(getErrors(state), 'editPageNameError');
export const getDeletePageError = state => _get(getErrors(state), 'deletePageError');
export const getDeletePageContentError = state => _get(getErrors(state), 'deletePageContentError');
export const getSetPageContentAvailabilityError = state => (
  _get(getErrors(state), 'setPageContentAvailabilityError')
);
export const getAddPageContentError = state => _get(getErrors(state), 'addPageContentError');
export const getEditPageContentError = state => _get(getErrors(state), 'editPageContentError');
export const getAddPageError = state => _get(getErrors(state), 'addPageError');
